// extracted by mini-css-extract-plugin
export default {"host":"II_NonManagerials_host__W5jtU","target":"II_NonManagerials_target__cIGrF","cardContainerBase":"II_NonManagerials_cardContainerBase__IxQPe"};